const unleashData = {
  toggles: [
    {
      name: 'marketing-modal-backoffice',
      enabled: true,
      variant: {
        name: 'image',
        enabled: true,
        payload: {
          type: 'json',
          value: JSON.stringify({
            image:
              'https://i.gojekapi.com/darkroom/gopay-merchants/v2/images/darkroom/9451713e-edf5-4c30-8e31-75e66b51bcbd_Moka---WPU---2024.jpeg',
            width: 600,
            height: 533,
            url: 'https://gjk.id/mokarenewal',
            cta: 'Marketing Modal Mock',
            caption:
              '**[PENTING] Informasi Pembayaran Langganan Moka POS**<br><br>Hai, Moka Merchant! **Kami mengimbau Anda untuk melakukan pembayaran langganan Moka POS hanya melalui Backoffice Moka POS dengan nomor virtual account Moka yang tersedia di berbagai pilihan bank** ~~bukan nomor perseorangan yang mengatasnamakan Moka Indonesia.~~<br><br>**Cara agar lebih aman, mudah, dan CUAN** dengan mengaktifkan fitur **Auto Renewal Tahunan**. Anda bisa dapatkan **diskon 35%** tiap tahun. Kuota terbatas, segera amankan diskonnya sekarang!',
            version: 4,
          }),
        },
      },
    },
    {
      name: 'backoffice-bundle-report-red-dot',
      enabled: true,
      variant: {
        name: 'disabled',
        enabled: false,
      },
    },
    {
      name: 'bundle-package-red-dot-ui',
      enabled: true,
      variant: {
        name: 'disabled',
        enabled: false,
      },
    },
    {
      name: 'ecommerce-attributes',
      enabled: true,
      variant: {
        name: 'disabled',
        enabled: false,
      },
    },
    {
      name: 'enable-gobiz-outlet-linking',
      enabled: true,
      variant: {
        name: 'disabled',
        enabled: false,
      },
    },
    {
      name: 'recurring-payment-backoffice',
      enabled: true,
      variant: {
        name: 'disabled',
        enabled: false,
      },
    },
    {
      name: 'backoffice-pukka-redirection',
      enabled: true,
      variant: {
        name: 'pukkaRedirection',
        enabled: true,
        payload: {
          type: 'json',
          value: JSON.stringify({
            '/library/discounts': '/v2/library/discounts',
            '/library/brands': '/v2/library/brands',
            '/reports/transactions': '/v2/reports/transactions',
            '/settings/customer-display': '/v2/customer-display/campaign',
            '/customer-display/campaign': '/v2/customer-display/campaign',
            '/customer-display/settings': '/v2/customer-display/settings',
            '/settings/billing': '/v2/settings/billing',
            '/payments/payment_methods': '/v2/payments/payment_methods',
          }),
        },
      },
    },
  ],
};

export { unleashData };
